import { MAX_SPEED, MIN_SPEED } from '../../../server/media/voice-tag.constants';
import { CHARACTERS, Character } from '../../../server/media/auto-tag.constants';

/** Slider stops, so the control lands on values a merchant can reason about. */
export const SPEED_STOPS = [
  { value: MIN_SPEED, label: 'Slowest' },
  { value: 0.85, label: 'Slower' },
  { value: 1, label: 'Normal' },
  { value: 1.1, label: 'Faster' },
  { value: MAX_SPEED, label: 'Fastest' },
];

const CHARACTER_COPY: Record<Character, { label: string; hint: string }> = {
  normal: { label: 'Normal', hint: 'The voice as recorded' },
  deep: { label: 'Deep', hint: 'Pitched down ~3 semitones' },
};

/** Pitch of the tag in the finished preview. Applied at render, not generation. */
export const TAG_CHARACTERS = CHARACTERS.map((value) => ({ value, ...CHARACTER_COPY[value] }));
